import ServiceMapping from './ServiceMapping';
export default class Service {

    /**
     * 创建服务实例
     * @param {String} className 服务名称
     * @param {Object} opts 服务初始化参数
     */
    // tslint:disable-next-line: member-access
    static createService(className: any, opts: any, egisCfg: any) {
        if (!(ServiceMapping as any)[className]) {
            throw new Error('服务类型不存在');
        }
        return new (ServiceMapping as any)[className].name(Object.assign({}, {
            url: egisCfg.server,
            authType: egisCfg.authType[className],
            tokenUrl: egisCfg.tokenServer,
            clientId: egisCfg.clientId,
            clientSecret: egisCfg.clientSecret,
        }, opts));
    }
    // constructor() { }
}
